<script>
import imageItem from '../ImageItem.vue';
import videoBackground from '../videoBackground.vue';

export default {
    components: {
        imageItem,
        videoBackground
    },

    props: {
        delay: {
            type: Number,
            default: 0.25
        },
        once: {
            type: Boolean,
            default: false
        },
        toggleActions: {
            type: String,
            default: 'play none play none'
        },
        scale: {
            type: Number,
            default: 1.5
        }
    },

    mounted() {
        gsap.fromTo(
            this.$refs.wrapper,
            {
                scale: this.scale,
                opacity: 0
            },
            {
                scale: 1,
                opacity: 1,
                duration: 1.2,
                delay: this.delay,
                ease: 'circ.out',
                scrollTrigger: {
                    trigger: this.$refs.wrapper,
                    once: this.once,
                    toggleActions: this.toggleActions
                }
            }
        );
    }
};
</script>
